import { toFlatField } from '../oasis-types';
export const NarrativeVersioned = {
    interventions: { e1: { alias: 'interventions', timepoint: ['soc', 'roc'] } },
    medicalNecessity: { e1: { alias: 'medicalNecessity', timepoint: ['soc', 'roc'] } },
    responseToCareAndProgress: { e1: { alias: 'responseToCareAndProgress', timepoint: ['soc', 'roc'] } },
    visitNarrative: { e1: { alias: 'visitNarrative', timepoint: ['soc', 'roc'] } },
};
export const Narrative = toFlatField(NarrativeVersioned);
